// extracted by mini-css-extract-plugin
export var checkbox = "_7t-0";
export var circle = "_7t-3";
export var horizontalContainer = "_7t-7";
export var sm = "_7t-5";
export var switch0 = "_7t-2";
export var switchDisabled = "_7t-8";
export var switchEnabled = "_7t-1";
export var textSwitchContainer = "_7t-9";
export var textSwitchOption = "_7t-a";
export var textSwitchOptionSelected = "_7t-b";
export var verticalContainer = "_7t-6";
export var xs = "_7t-4";